// extracted by mini-css-extract-plugin
export default {"attachments__header":"VoterEventDetailsAttachments_attachments__header__X75o9","attachments__header__text":"VoterEventDetailsAttachments_attachments__header__text__64fdA"};